import type { TextDocumentRevisionItem, TextDocumentRevisionReason } from '@/api/services/memo'
import { parseUtcDate } from '@/lib/date-utils'

export const REVISION_REASON_LABEL: Record<TextDocumentRevisionReason, string> = {
  auto: '自動',
  shrink: '大きく削る前',
  overwrite: '上書き前',
  restore: '復元前',
  delete: '削除前',
}

/** この本文が保存された日時（無ければ履歴に残した日時） */
export const formatRevisionSavedAt = (item: TextDocumentRevisionItem): string =>
  parseUtcDate(item.source_updated_at ?? item.created_at).toLocaleString('ja-JP', {
    month: 'numeric',
    day: 'numeric',
    weekday: 'short',
    hour: '2-digit',
    minute: '2-digit',
  })
